import weui from '../../../node_modules/weui.js/dist/weui.js'

export default function (message, duration = 1350) {
  weui.toast(message, {
    duration: duration,
    className: 's-toast'
  })
}



// WEBPACK FOOTER //
// ./src/public-lib/vue-components/src/components/c-toast/index.js